import React, { useState, useContext, useRef, useEffect, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { statusDisplayName } from '../../../../../utils/statusDisplayName'
import { Droppable } from 'react-beautiful-dnd';
import InfluencerItem from './InfluencerItem';
import { SharedCampaignContext } from '../../../../../contexts/Advertiser/SharedCampaignContext';

export default observer(function InfluencerStatusColumn({ status, dragHandleProps }) {
  const [showOptions, setShowOptions] = useState(false)
  const modalRef = useRef()

  const { authentications } = useContext(SharedCampaignContext)
  const auths = authentications.filter(auth => auth.status_id === status?.id)

  const statusName = useMemo(() => statusDisplayName(status), [status?.name, status?.system_key])

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setShowOptions(false)
    }
  };

  useEffect(() => {
    showOptions ?
      document.addEventListener('mousedown', handleClickOutside) :
      document.removeEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [showOptions])

  return (
    <div className='py-3'>
      <div
        className="h-10 flex justify-between items-center px-2 mb-2 cursor-move"
        {...dragHandleProps}
      >
        <div className='flex'>
          <h2 className="dark:text-white" style={{ color: '#143955', fontWeight: 700 }}>{statusName}</h2>
          <h3 className='ml-2 dark:text-gray-400' style={{ color: '#A1B1BC'}}>{auths.length > 0 ? auths.length : ''}</h3>
        </div>
      </div>
      <div className='flex flex-col border-2 border-gray-100 dark:border-rb-dark-mode-lighter w-80 rounded-lg p-4 bg-white dark:bg-rb-dark-mode min-h-40'>
        <Droppable droppableId={`${status?.id}`} type="influencer" isDropDisabled>
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              className='mt-2 w-full'
            >
              {
                auths.map((auth, index) => (
                  <InfluencerItem
                    key={auth.authentication_id}
                    index={index}
                    auth={auth}
                  />
                ))
              }
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </div>
    </div>
  );
})
